export const LWW_DOC = { type: 'last_write_wins' };
/**
 * Define the config as a whole. This is the root of the config tree.
 * Each child must be defined separately. If they are defined inline the types won't be accurate. Example:
 *
 * import { users } from './users';
 * import { projects } from './projects';
 *
 * export const config = defineConfig({
 *   name: 'my-app',
 *   domain: 'my-app.agreeable.cloud',
 *   children: {
 *     users,
 *     projects,
 *   },
 * });
 */
export function defineConfig(config) {
    const assignParent = (parent) => parent.children && Object.values(parent.children).forEach(child => (child.parent = parent));
    assignParent(config);
    return config;
}
export function defineDoc(type, config) {
    if (typeof type === 'function') {
        return config;
    }
    else {
        return type;
    }
}
/**
 * A placeholder type for a JSON object. This is used to define the shape of a document in the config. Example:
 *
 * const user = defineDoc(Type<User>, { ... });
 */
export const Type = () => {
    return undefined;
};
export function getDocConfig(config, path) {
    const parts = path.split('/');
    let docConfig = config.children[parts[0]];
    for (let i = 1; i < parts.length && docConfig; i++) {
        if (parts[i] === 'roles' && docConfig.access === 'role') {
            return LWW_DOC;
        }
        else if (parts[i] === 'versions' && docConfig.versioned) {
            return LWW_DOC;
        }
        else if (docConfig?.children?.[parts[i]]) {
            docConfig = docConfig?.children?.[parts[i]];
        }
        else if (i === parts.length - 1 && !docConfig?.isCollection) {
            docConfig = undefined;
        }
    }
    if (!docConfig?.type) {
        throw new Error('No doc config found for path ' + path + ' or type missing');
    }
    return docConfig;
}
